import columns from '../../react-table/helpers/columns';

export default (data) => {
  const {
    NumberColumn,
    TextColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('', 'name'),
        new NumberColumn('', 'used'),
      ],
    },
  ];
};
